import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import "./NewButton.sass";

function NewButton({ children, type, className, onClick, ...rest }) {
  const classes = classNames("btn_new", className);
  return (
    <button className={classes} type={type} onClick={onClick} {...rest}>
      {children}
    </button>
  );
}

NewButton.defaultProps = {
  type: "submit",
  children: "",
  className: "",
  onClick: () => {},
};

NewButton.propTypes = {
  type: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  onClick: PropTypes.func,
};

export default NewButton;
